import React, { KeyboardEventHandler } from 'react';
import c from 'classnames';
import AutoCompleteMenu from './AutoCompleteMenu';
import { getDescendentId } from './utils';
import { useAutoCompleteKeyboardSupport } from './hooks';
import s from './AutoCompleteLayout.scss';

interface Props {
  /** For a11y */
  menuId: string;

  items: any;

  className?: string;
  onSelect?: any;

  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
}

const AutoCompleteLayout: React.FC<React.PropsWithChildren<Props>> = ({
  items,
  menuId,
  onSelect,
  children,
  className,
  onKeyDown,
}) => {
  const [selectedIndex, handleKeyDown] = useAutoCompleteKeyboardSupport(items, onSelect, onKeyDown);

  return (
    <div
      id={menuId}
      className={c(s['root'], className)}
      role="combobox"
      aria-activedescendant={items.length > 0 ? getDescendentId(menuId, selectedIndex) : undefined}
      aria-controls={menuId}
      aria-expanded={items.length > 0}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      {children}
      {items.length > 0 && (
        <AutoCompleteMenu
          menuId={menuId}
          items={items}
          selectedIndex={selectedIndex}
          onSelectItem={onSelect}
        />
      )}
    </div>
  );
};
AutoCompleteLayout.displayName = 'AutoCompleteLayout';

export default AutoCompleteLayout;
